import { PageController } from '@client/components/_core/layout/PageController';
import { useUser } from '@client/hooks/business/user/useUser';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { IncidentDetailsManage } from '../IncidentDetailsManage';
import { canEditIncident } from '../permissions';
import { incidentFormStore } from '../store';

export const Route = createFileRoute('/console/$orgId/compliance/incidents/details/$id/manage')({
    component: IncidentManageTab,
});

function IncidentManageTab() {
    const user = useUser();
    const incident = incidentFormStore.use.formData();
    const canEdit = canEditIncident(user, incident);

    return (
        <PageController route={Route}>
            <Outlet />
            <IncidentDetailsManage isReadOnly={!canEdit} />
        </PageController>
    );
}
